import axios from '@/api/config';

const signLog = {
    getSignLogList(data) {
        return axios.get(`${process.env.BASE_URL}/signLog/getSignLogList`, { params: data });
    },
}

export default signLog;


// WEBPACK FOOTER //
// ./src/api/signLog.js